@import 'styles/mixins';
@import 'styles/variables';

.projectLink {
  @include md-regular;

  border-radius: 4px;
  color: $grey-40;
  cursor: pointer;
  padding: 6px 4px;

  &:hover {
    background-color: $grey-5;
  }

  .breadcrumb {
    @include md-regular;

    align-items: center;
    border-radius: 4px;
    color: $grey-40;
    display: flex;

    .folderButtonText {
      max-width: 146px;
      margin-left: 5px;

      @include line-clamp(1);
    }

    svg {
      fill: transparent !important;
      min-width: 16px;
      min-height: 16px;
    }
  }
}

.divider {
  color: $grey-20;
  margin: 0 2px;
}

.currentFolder {
  @include md-regular;

  align-items: center;
  color: $grey-50;
  display: flex;
  padding-left: 1px;
  gap: 8px;
  padding-right: 6px;
  border-radius: 4px;
  border: 1px solid transparent;
  transition: all 200ms;
  cursor: pointer;

  .tooltip {
    :global {
      .ant-tooltip-arrow {
        display: none;
      }

      .ant-tooltip-inner {
        @include sm-medium;

        background: $navy-90;
        color: $white;
        min-height: 24px;
        padding: 4px 8px;
        text-align: center;
      }
    }
  }

  input {
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  .folderIcon {
    margin-right: 5px;
  }

  .folderButtonText {
    @include line-clamp(1);

    color: $grey-50;
    max-width: 280px;
    cursor: text;

    @include for-phone-only {
      max-width: 200px;
    }
  }

  &.canEdit {
    gap: 0px;

    &:hover {
      border-color: $grey-10;
    }

    &.isEditing {
      border-color: $green-50 !important;
      box-shadow: 0 0 0 3px rgba(0, 163, 158, 0.11);

      input {
        min-width: 100px;
        cursor: text;
      }
    }
  }
}
